import { parseChapterSections } from "@/zapi-frontend/shared/lib/contentBlocks";
import { headlineDisplay, type TFigureLookup } from "@/zapi-frontend/shared/lib/figureRefs";
import type { TContentBlock } from "@/zapi-frontend/shared/types/contentBlocks";

const cell = (text: string) =>
  text
    .replace(/\r?\n+/g, " ")
    .replace(/\|/g, "\\|")
    .trim();

const markdownTable = (cols: string[], rows: string[][]) => {
  const line = (cells: string[]) => `| ${cells.map(cell).join(" | ")} |`;
  return [line(cols), `| ${cols.map(() => "---").join(" | ")} |`, ...rows.map(line)].join("\n");
};

const blockMarkdown = (block: TContentBlock, blocks: TContentBlock[], figures?: TFigureLookup): string => {
  switch (block.kind) {
    case "prose":
      return block.text;
    case "pullQuote": {
      const quoted = block.from ? blocks.find((other) => other.kind === "prose" && other.id === block.from) : undefined;
      const text = block.text ?? (quoted?.kind === "prose" ? quoted.text : "");
      return text ? [block.label, `> ${text}`].filter(Boolean).join("\n") : "";
    }
    case "headline":
      return [
        block.label,
        ...block.items.map(
          (item) => `- ${item.label}: ${headlineDisplay(item, item.key ? figures?.get(item.key) : undefined)}`
        )
      ]
        .filter(Boolean)
        .join("\n");
    case "table":
      return [block.label, markdownTable(block.cols, block.rows), block.render?.note].filter(Boolean).join("\n\n");
    case "chain":
      return "";
  }
};

export const chapterMarkdown = (content: string, figures?: TFigureLookup): string =>
  parseChapterSections(content)
    .map((section) =>
      [
        `## ${section.title}`,
        section.intent,
        ...section.blocks.map((block) => blockMarkdown(block, section.blocks, figures))
      ]
        .filter(Boolean)
        .join("\n\n")
    )
    .join("\n\n");
